<template lang="pug">
div.insp-actions(v-show="target")
  div.action-item(v-for="act in actions" :key="act.code")
    div.action-btn(@click="handleAction(act)")
      a-icon(:type="act.icon || 'smile'")
      span.p1 {{ act.name }}
  Accept(ref="accepting" :target="target" @modal-success="handleDoActionSuccess")  
  Complete(ref="completing" :target="target" @modal-success="handleDoActionSuccess")
  Transfer(ref="transferring" :target="target" @modal-success="handleDoActionSuccess")
  Reject(ref="rejecting" :target="target" @modal-success="handleDoActionSuccess")
  Print(ref="print" :target="target" @modal-success="handleDoActionSuccess")
</template>

<script>
import Accept from './Accept';
import Complete from './Complete';
import Transfer from './Transfer';
import Reject from './Reject';
import Print from './Print';

import moment from 'moment';

import { GETTER_PROJECT, GETTER_USER } from '@store/account';
import { mapGetters } from 'vuex';
export default {
  components: { Accept, Complete, Transfer, Reject, Print },
  props: {
    target: Object,
  },
  data() {
    return {
      actionSheets: [],
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
      user: GETTER_USER,
    }),
    actions() {
      const _actions = this.target?.actions || []; // [accept，transfer，complete，appraise]
      const actions = this.actionSheets.filter((item) => {
        return item.shouldShow(_actions);
      });
      return actions;
    },
  },
  created() {
    this.initActionSheets();
  },
  methods: {
    moment,
    handleAction(action) {
      if (action.type === 'confirm') {
        this.$confirm({
          title: '提示',
          content: `确定${action.name}？`,
          onOk: async () => {
            // await this.doAction('accepting', { ticketinstId, userTaskId });
            this.handleDoActionSuccess();
            this.$message.success('操作成功!');
          },
        });
      } else if (action.type === 'modal') {
        this.$refs[action.code].show();
      } else {
        this[action.code]();
      }
    },
    handleDoActionSuccess() {
      this.$emit('do-action-success');
    },
    back() {
      this.$back();
    },
    reload() {
      if (this.target.id) {
        this.$emit('reload');
      } else {
        this.$back();
      }
    },
    preview() {
      // 预览
    },
    save() {
      this.$emit('save');
    },
    completing() {
      this.$confirm({
        title: '确定完成订单?',
        // content: ' ',
        onOk: () => {
          return new Promise((resolve, reject) => {
            // 校验 请先完成产品出入库 warehouseId warehousePartitionId
            let validation = true;
            if (this.target.stockType !== 'stockType_other') {
              this.target.orderItems.forEach((item) => {
                if (!item.warehouseId || !item.warehousePartitionId) {
                  //warehousePartitionId
                  validation = false;
                }
              });
            }
            if (validation) {
              this.$restful(`POST:/prj/orders/completing`, {
                ...this.target,
                projectId: this.project.id,
                taskId: this.target.id,
              })
                .then(() => {
                  resolve();
                  this.$back();
                })
                .catch(() => {
                  reject();
                });
            } else {
              this.$message.warn('请先完成产品出入库信息!');
              reject();
            }
          });
        },
        onCancel() {},
      });
    },
    initActionSheets() {
      this.actionSheets = [
        {
          name: '返回',
          code: 'back',
          type: 'none',
          icon: 'arrow-left',
          shouldShow() {
            return true;
          },
        },
        {
          name: '刷新',
          code: 'reload',
          type: 'none',
          icon: 'redo',
          shouldShow: () => {
            return !!this.target?.id;
          },
        },
        // {
        //   name: '预览',
        //   code: 'preview',
        //   type: 'none',
        //   icon: 'eye',
        //   shouldShow: (actions) => {
        //     return actions.includes('preview');
        //   },
        // },
        {
          name: '打印',
          code: 'print',
          type: 'modal',
          icon: 'printer',
          shouldShow: (actions) => {
            return actions.includes('print');
          },
        },
        {
          name: '保存',
          code: 'save',
          type: 'none',
          icon: 'save',
          shouldShow: (actions) => {
            return !this.target?.id || actions.includes('save');
          },
        },
        {
          name: '转单',
          code: 'transferring',
          type: 'modal',
          icon: 'rollback',
          shouldShow: (actions) => {
            return actions.includes('transfer');
          },
        },
        {
          name: '驳回',
          code: 'rejecting',
          type: 'modal',
          icon: 'close-circle',
          shouldShow: (actions) => {
            return actions.includes('reject');
          },
        },
        {
          name: '完成',
          code: 'completing',
          type: 'none',
          icon: 'smile',
          shouldShow: (actions) => {
            return actions.includes('completed');
          },
        },
      ];
    },
  },
};
</script>
<style lang="less" scoped>
.insp-actions {
  position: absolute;
  left: 50%;
  bottom: 24px;
  height: 46px;
  // width: 200px;
  padding: 0 12px;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 4px;
  display: flex;
  align-items: center;
  .action-item {
    height: 36px;
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 16px;
    position: relative;
    cursor: pointer;
    & + .action-item {
      margin-left: 24px;
      &::before {
        display: block;
        content: ' ';
        height: 18px;
        width: 1px;
        background-color: rgba(255, 255, 255, 0.4);
        position: absolute;
        left: -12px;
      }
    }
    .action-btn {
      padding: 0 12px;
      display: flex;
      align-items: center;
      white-space: nowrap;
      &:hover {
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }
}
</style>
